jQuery(function ($) {

    //Watch all ajax activity
    $(document).ajaxStart(function () {

        if ($('#loading-bar').length === 0) {

            $('body').append($('<div/>').attr('id', 'loading-bar').addClass(_lb.position));
        }
       
        $('#loading-bar').show();

        /**
         * Random loading bar initial percentage
         */
        _lb.percentage = 20;
        $("#loading-bar")[_lb.direction](_lb.percentage + "%");

        /**
         * Bump loading percentage between current and 99%
         */
        _lb.interval = setInterval(function () {

            _lb.percentage = _lb.percentage + 20;
           

            $("#loading-bar")[_lb.direction](_lb.percentage + "%");

            if (_lb.percentage >= 100) {
                clearInterval(_lb.interval);
                _lb.percentage = 100;
                $("#loading-bar")[_lb.direction](_lb.percentage + "%");
                setTimeout(function() {
                    $('#loading-bar').hide();
                }, 1000);
            }

        }, 100);



    }).ajaxStop(function () {
        /*clearInterval(_lb.interval);
        _lb.percentage = 0;
        $("#loading-bar")[_lb.direction](_lb.percentage + "%");
        */
    });

});

/**
 * Main object
 */
var _lb = {}

//Default loading bar position
_lb.position = 'top';
_lb.direction = 'width'

/**
 * Ajax call
 * accepts callback( response )
 */
_lb.get = function (callback) {

    _lb.loading = true;

    jQuery.ajax({
        url: this.href,
        success: function (response) {
            _lb.loading = false;
            if (typeof (callback) === 'function')
                callback(response);
        }
    });

}
/*
jQuery(function ($) {

    $('.btn-action').click(function () {

        switch ($(this).data('action')) {

            case 'load':
                _lb.get();
                break;

            case 'position':
                _lb.position = $(this).data('position');
                _lb.direction = $(this).data('direction');
                $('#section-position h1 small').html(_lb.position);
                break;

        }

    });

});
*/